import { Group, Text, Box } from '@mantine/core'
import { useArcTranslation } from 'hooks'

interface Props {
  canFillDownGroup: boolean
  canFillDownGrade: boolean
  onFillDownGroup: () => void
  onFillDownGrade: () => void
}

export function RequestsTableHeader({ canFillDownGroup, canFillDownGrade, onFillDownGroup, onFillDownGrade }: Props) {
  const { t } = useArcTranslation()

  return (
    <Group noWrap spacing='sm' px='md' py='sm' sx={theme => ({
      backgroundColor: theme.colors.gray[0],
      borderBottom: `1px solid ${theme.colors.gray[2]}`,
    })}>
      <Text weight={600} size='sm' sx={{ flex: '1 1 25%', minWidth: 0 }}>
        {t('student_requests.student_name')}
      </Text>
      <Group spacing={4} sx={{ flex: '1 1 30%', minWidth: 0 }}>
        <Text weight={600} size='sm'>{t('student_requests.group')}</Text>
        {canFillDownGroup && (
          <Text size='xs' color='violet' weight={500} sx={{ cursor: 'pointer' }} onClick={onFillDownGroup}>
            ({t('student_requests.fill_down')})
          </Text>
        )}
      </Group>
      <Group spacing={4} sx={{ flex: '1 1 20%', minWidth: 0 }}>
        <Text weight={600} size='sm'>{t('student_requests.grade')}</Text>
        {canFillDownGrade && (
          <Text size='xs' color='violet' weight={500} sx={{ cursor: 'pointer' }} onClick={onFillDownGrade}>
            ({t('student_requests.fill_down')})
          </Text>
        )}
      </Group>
      <Box sx={{ flex: '0 0 25%', minWidth: 0 }} />
    </Group>
  )
}
